import { uncapitalize } from '@attain-apps/string-utils'

import * as core from '../../../../../../core'
import * as common from '../../../../../common'

import * as leaderType from './leader-type'

// NOTE: everything below is designed to simulate a normal folder/module
// structure for exporting resources from separate files. This just simply
// generates those resources based on the known enum entries

const enumId = core.dms.models.Enum.Id.from({
  partialId: leaderType.RESOURCE.payload.partialId,
})

const enumEntryResourceNameLookup = {} as Record<common.LeaderType, string>
for (const enumEntryName in common.LeaderType) {
  const potentialEnum =
    common.LeaderType[enumEntryName as keyof typeof common.LeaderType]
  if (common.LeaderType.isLeaderType(potentialEnum)) {
    enumEntryResourceNameLookup[potentialEnum] = uncapitalize(enumEntryName)
  }
}

export const entries = common.LeaderType.ALL.reduce(
  (prev, _leaderType) =>
    Object.assign(prev, {
      [enumEntryResourceNameLookup[_leaderType]]: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        RESOURCE: {
          payload: {
            ...common.LeaderType.getEntry(_leaderType),
            enumId,
          },
          type: core.quiver.Resource.Type.DmsEnumEntry,
        } as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>,
      },
    }),
  {} as {
    [K in keyof typeof common.LeaderType as (typeof common.LeaderType)[K] extends common.LeaderType
      ? Uncapitalize<K>
      : never]: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      RESOURCE: core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
    }
  },
)
